import Vue from 'vue'
import * as TYPES from './types'

export default {
  [TYPES.SET_BOTTLES](state, bottles) {
    if (bottles && Array.isArray(bottles)) {
      Vue.set(state, 'bottles', bottles)
    }
  }
}
